import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import EventTypeTab from '../../components/Tab/EventTypeTab';
import { getEventTypeSvgIcon } from '../../utilities';

const CategoriesFilter = ({ categoryKeys, filters, handleDirectFilterChange, tCategories }) => {
  return (
    <CategoriesFilters>
      {categoryKeys.map((category) => (
        <EventTypeTab
          key={category}
          category={tCategories(`type.${category}`)}
          isActive={filters.typology.includes(category)}
          onClick={() => handleDirectFilterChange('typology', category)}
          icon={getEventTypeSvgIcon(
            category,
            filters.typology.includes(category) ? theme.colors.brandMain : theme.colors.defaultSubtle
          )}
          iconSize="24px"
        />
      ))}
    </CategoriesFilters>
  );
};

export default CategoriesFilter;

const CategoriesFilters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.sm};
  // padding-left: ${({ theme }) => theme.sizing.sm};
  overflow-x: auto;
`;